import { BaseService } from './base.service'

export class SupportService extends BaseService {
  static sendRequestSupportForm (data) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('RequestForm/AllowRegister', data)
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getListRequestType () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('RequestForm/GetRequestType')
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getListPlateNo () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('RequestForm/GetPlateNos')
        .then(response => {
          resolve(this.responseWrapper(response, response.data.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
